import { formatInvoiceMoney } from './formatInvoiceMoney';
import type { AgreementInvoice } from '../types/agreements.types';

type FundingFields = Pick<
    AgreementInvoice,
    'fundingType' | 'totalGross' | 'claimedGross' | 'shortfallGross'
>;

export function invoiceFundingBadge(invoice: FundingFields): string | null {
    if (invoice.fundingType === 'arrears') {
        return `Arrears override, excess ${formatInvoiceMoney(invoice.shortfallGross)}`;
    }
    if (invoice.fundingType === 'pot_total') {
        return `Pot total, invoiced ${formatInvoiceMoney(invoice.totalGross)}, claimed ${formatInvoiceMoney(invoice.claimedGross)}`;
    }
    return null;
}
